webpackJsonp([244657766900373],{

/***/ 484:
/***/ (function(module, exports) {

	module.exports = {"data":{"contentfulMember":{"name":"Miguel Yee Bacaoco","designation":null,"thumbnail":{"file":{"url":"//images.ctfassets.net/1o5ly3na7qu2/49wkEYkYS4iyuu4UOQ8000/a098f0ba05458adc916b9a01d52ba657/Miguel.jpg"}},"content":{"content":"Manila Street Astronomer Miguel Yee Bacaoco is a 4th year BS Physics student at the University of the Philippines, Diliman, and part of the Condensed Matter Physics Laboratory - Semiconductor Research Group. He is currently an associate member of UP Astronomical Society. His areas of interests include astronomical observation and instrumentation, astronomical heritage, ethno-astronomy, and computational astronomy. \n\nOutside the lab, Miguel also enjoys photography (astrophotography, street photography, and covering various events), reading books on humanities and social sciences, and advocates for smart urban design and heritage conservation. \n\nYou, too, can be a volunteer astronomer. Join us!"}}},"pathContext":{"id":"c6mUc4cSP1SsUyiqgusS6Sy"}}

/***/ })

});


// WEBPACK FOOTER //
// path---member-miguel-yee-bacaoco-c94b760eb8c617fb5e48.js